import { AppUser } from './AppAuthenticator'

const CURRENT_USER_STORAGE_KEY = 'routex.current-user'

export function persistCurrentUser(user?: AppUser | null): void {
  if (!user) {
    localStorage.removeItem(CURRENT_USER_STORAGE_KEY)
    return
  }
  localStorage.setItem(CURRENT_USER_STORAGE_KEY, JSON.stringify(user))
}

export function clearCurrentUser(): void {
  localStorage.removeItem(CURRENT_USER_STORAGE_KEY)
}

export function getStoredCurrentUser(): AppUser | undefined {
  const raw = localStorage.getItem(CURRENT_USER_STORAGE_KEY)
  if (!raw) return undefined
  try {
    return new AppUser(JSON.parse(raw))
  } catch {
    localStorage.removeItem(CURRENT_USER_STORAGE_KEY)
    return undefined
  }
}
